import { CalendarDays } from 'lucide-react';
import { formatDateRangeWithYear } from '@/utils/date';
import { PillBadge } from './PillBadge';

interface DateRangeBadgeProps {
  dateFrom: string | undefined;
  dateTo: string | undefined;
}

export function DateRangeBadge({ dateFrom = '', dateTo = '' }: DateRangeBadgeProps) {
  if (!dateFrom && !dateTo) return null;

  return (
    <PillBadge icon={CalendarDays} screenReaderLabel="Date range:">
      {formatDateRangeWithYear(dateFrom, dateTo)}
    </PillBadge>
  );
}
